import { useState } from "react"

import "../../styles/Dining.css"

import Banner from "../navigation/Banner"
import NavBarOrder from "../navigation/NavBarOrder"
import Footer from "../navigation/Footer"
import WarnModal from "../navigation/WarnModal"

function Catering() {
  const [ warnModal, setWarnModal ] = useState(false)
  const [ warnNav, setWarnNav ] = useState("")

  return (
    <div className="dining-page-container" >
      <Banner />
      <NavBarOrder setWarnNav={setWarnNav} setWarnModal={setWarnModal} />

      <div className="dining-page-content-container">
        <div className="dining-content-1">
          <h1>Catering / Banquet Hall</h1>
        </div>

        <div className="dining-content-2">

          {/* Policies and Information */}

          <div className="dining-section-header">
            <span>Policies and Information</span>
          </div>

          <div className="catering-section-container">
            <button className="order-now-button">Inquire to schedule event</button>

            <span style={{fontWeight: "bold", textDecoration: "underline"}}>Schedule time of functions</span>
            <span>(Hours of events are flexible)</span><br/>

            <div className="catering-schedule-time-container">
              <div className="catering-schedule-time-left">
                <span className="catering-schedule-time">Breakfast:</span>
                <span className="catering-schedule-time">Brunch:</span>
                <span className="catering-schedule-time">Daytime:</span>
                <span>Evening:</span>
              </div>
              <div className="catering-schedule-time-right">
                <span className="catering-schedule-time">9:00am - 12:30pm</span>
                <span className="catering-schedule-time">11:00am - 3:00pm</span>
                <span className="catering-schedule-time">12:00pm - 4:00pm</span>
                <span>6:00pm - 10:00pm</span>                
              </div>
            </div>

            <br/><span>Room rental fee is $200, bartender, valet, table linens, and room set-up included.</span>
            <span>A non-refundable deposit of $150 is required to reserve a specific date.</span>
            <span>$150 for each additional hour over allotted time, up to 4 hrs.</span><br/>


            <span>Table linens included are available in white, champagne or black with your choice of colored napkins, ask to see chart.</span>
            <span>Floor length linens are available in white, champagne or black for $15.00 per table.</span>
            <span>Chair covers are available in white, champagne or black for $2.00 per chair.</span>
            <span>Chair cover sash bow are available in white, ivory, fuchsia, pink, black, silver, purple, sage, and light blue for $1.00 per chair.</span>
            <span>Envelop basket, cake knife and server, podium, and giant screen are available upon request at no extra charge.</span><br/>
            
            <span style={{fontWeight: "bold"}}>For all off-premises events, additional fees apply aside from gratuity and taxes. Dependant on where the venue is and the amount of work or help involved. Ask your banquet coordinator for details.</span><br/>

            <div className="catering-left-align">
              <span>- Our staff will greet you and your guests upon arrival and will guide you throughout the function.</span>
              <span>- This is a non-smoking facility.</span>
              <div style={{flexFlow: "row"}}>
                <span>- Dinner selections as well as selection of beverages, linens, set-up, and any extra details must be received </span><span style={{textDecoration: "underline"}}>4 weeks</span><span> prior to the function.</span>
              </div>
              <div style={{flexFlow: "row"}}>
                <span>- Please inform if anyone has any food allergies, or is a vegetarian, or needs a special meal prepared for them at least </span><span style={{textDecoration: "underline"}}>4 weeks</span><span> prior to function.</span>
              </div>
              <div style={{flexFlow: "row"}}>
                <span>- Seating plan, final counts, meal choice breakdown and final details must be received </span><span style={{textDecoration: "underline"}}>1 week</span><span> prior to event. We will be prepared to serve up to 5 people more than the guaranteed count, you are responsible to pay for your guaranteed count.</span>
              </div>
              <span>- RI law prohibits liquor, wine or beer brought onto or removed from the premises.</span>
              <span>- Under no circumstances at all are confetti, glitter, rice, nails, thumb tacks or sticky tape allowed to be used as decoration, no exceptions.</span>
              <span>- All items such as cake knife, favors, toast glasses, seating cards, guest books, and pens should be brought in the morning of the function.</span>
              <span>- All live entertainment volume will be regulated under the control of Via Roma Management. Background music is available with CD's and iPod dock available.</span>
              <span>- We will hold a specific date for up to one week; if a deposit is not received that date will no longer be held.</span>
              <span>- All dinners and liquors are subject to a 20% taxable service charge and Rhode Island Sales and Meals and Beverage Tax of 8%. Use your discretion if you are adding an additional gratuity.</span>
              <span>- Prices are subject to change without notice to meet increased costs.</span>
              <span>- We are not responsible for anything lost or left behind by the host or their guests.</span>
              <span>- Hosts are allowed in 45 minutes prior to their event to decorate.</span>
              <span>- Should collection services be necessary, customer will be responsible for all collection and attorney fees.</span><br/>
            </div>   

            <span style={{fontWeight: "bold"}}>Please inquire about having Via Roma cater your next occasion, either at our Banquet Hall or at your home, office, or anywhere in New England!</span><br/>

            <button className="order-now-button">Inquire to schedule event</button>
          </div>

          {/* Breakfast / Brunch */}

          <div className="dining-section-header">
            <span>Breakfast / Brunch Packages</span>
          </div>

          <div className="catering-section-container">
            <div className="catering-left-align">
              <button className="order-now-button">Inquire to schedule event</button>

              <span>* Buffet style or served</span>
              <span>* Add Belgian Waffles with Fresh Berries and Whipped Cream for $1.50 per person</span>
              <span>* Substitute Scrambled Eggs for either Eggs Benedict or Vegetable and Cheese Omelet for $1.95 per person</span>
              <span>* Add Assorted Mini Pastry & Assorted Biscotti for $18.00 per dozen</span><br/>
            

              <span style={{fontWeight: "bold"}}>- BREAKFAST / BRUNCH PACKAGES</span>
              <span>($27.95 per person)</span><br/>

              <span>Fresh Fruit</span>
              <span>Breakfast Pastry</span>
              <span>Scrambled Eggs</span>
              <span>Home Fries</span>
              <span>Toast</span>
              <span>Unlimited Juice, Coffee, and Tea</span><br/>

              <span>Choice of:</span>
              
              <div style={{flexFlow: "row"}}>
                <span style={{textDecoration: "underline"}}>One meat:</span><br/><span> Bacon - Ham - Breakfast Sausage</span>
              </div>
              <div style={{flexFlow: "row"}}>
                <br/><span style={{textDecoration: "underline"}}>One bread:</span><br/><span> French Toast - Pancakes</span>
              </div>
              <div style={{flexFlow: "row"}}>
                <br/><span style={{textDecoration: "underline"}}>One salad:</span><br/><span> Fresh Garden - Caesar - Mesclun</span>
              </div>
              <div style={{flexFlow: "row"}}>
                <br/><span style={{textDecoration: "underline"}}>One pasta:</span><br/><span> Penne Pomodoro - Tortellini Pink Vodka - Bow Tie Broccoli Aglio e Olio</span>
              </div>
              <div style={{flexFlow: "row"}}>
                <br/><span style={{textDecoration: "underline"}}>One chicken:</span><br/><span> Chicken Marsala - Chicken Piccata - Chicken Francese</span>
              </div>
              <div style={{flexFlow: "row"}}>
                <br/><span style={{textDecoration: "underline"}}>One side:</span><br/><span> Grilled Vegetables - Green Beans Aglio e Olio - Sauteed Vegetables</span>
              </div>
            </div>
          </div>

          {/* Buffet */}

          <div className="dining-section-header">
            <span>Buffet Style Packages</span>
          </div>
          
          <div className="catering-section-container">
            <div className="catering-left-align">
              <button className="order-now-button">Inquire to schedule event</button>
              
              <span>* Buffet includes Bread, Butter, Vanilla Ice Cream & Coffee</span>
              <span>* Add soup to any buffet for $3.00 per person: Pasta Fagioli - Chicken Escarole Minestrone - Escarole & Beans - Tuscan Tomato</span>
              <span>* Add desserts to any buffet for $3.95 per person: Assorted Mini Pastry & Assorted Biscotti - Spumoni Wedges - Fresh Season Fruits</span><br/>

              <span style={{fontWeight: "bold"}}>- LIGHTER FARE</span>
              <span>($19.95 per person)</span><br/>
              <span>Choice of:</span>              
              <div style={{flexFlow: "row"}}>
                <span style={{textDecoration: "underline"}}>One salad:</span><br/><span> Fresh Garden - Caesar - Pasta - Macaroni - Potato - Italian Potato - Green Bean - Broccoli</span>
              </div>
              <div style={{flexFlow: "row"}}>
                <br/><span style={{textDecoration: "underline"}}>Two finger sandwiches:</span><br/><span> Tuna - Italian Tuna - Chicken Salad - Crab Meat - Roast Beef & Cheese - Turkey & Cheese - Italian - Grilled Vegetables & Cheese</span>
              </div>
              <div style={{flexFlow: "row"}}>
                <br/><span style={{textDecoration: "underline"}}>Two snacks:</span><br/><span> Chocolate Chip Cookie - Fresh Fruit - Oatmeal Raisin Cookie - Brownie - Potato Chips - Yogurt</span>
              </div><br/>

              <span style={{fontWeight: "bold"}}>- THE BASICS</span>
              <span>($27.95 per person)</span><br/>
              <span>Choice of:</span>              
              <div style={{flexFlow: "row"}}>
                <span style={{textDecoration: "underline"}}>One appetizer:</span><br/><span> Margherita Pizza - Caprese Bruschetta - Cold Cut - Spinach & Cheese Calzone - Spanakopita</span>
              </div>
              <div style={{flexFlow: "row"}}>
                <br/><span style={{textDecoration: "underline"}}>One salad:</span><br/><span> Fresh Garden - Caesar - Baby Greens</span>
              </div>
              <div style={{flexFlow: "row"}}>
                <br/><span style={{textDecoration: "underline"}}>One pasta:</span><br/><span> Penne Pomodoro - Bow Tie Pink Vodka - Rigatoni Bolognese - Fusilli Broccoli Aglio e Olio</span>
              </div>
              <div style={{flexFlow: "row"}}>
                <br/><span style={{textDecoration: "underline"}}>Two entrees:</span><br/><span> Chicken Parmigiana - Roast Pork Loin - Sausage & Peppers - Chicken Francese - Eggplant Parmigiana - Meatballs Parmigiana - Meatballs Pomodoro - New England Style Baked Cod - Chicken Piccata - Roasted Bone-in Quarter Chicken - Sole Francese</span>
              </div>
              <div style={{flexFlow: "row"}}>
                <br/><span style={{textDecoration: "underline"}}>One side dish:</span><br/><span> Sauteed Vegetables - Baby Red Roasted Potatoes - Rice Pilaf - Green Beans - Grilled Vegetables</span>
              </div><br/>

              <span style={{fontWeight: "bold"}}>- DaHILL</span>
              <span>($36.95 per person)</span><br/>
              <span>Choice of:</span>              
              <div style={{flexFlow: "row"}}>
                <span style={{textDecoration: "underline"}}>Two appetizers:</span><br/><span> Stuffed Mushroom Caps - Melon Wrapped with Prosciutto - Vegetable Pot Stickers - Tomato, Onion & Cheese Focaccia - Eggplant Crostini - Pesto Grilled Pizza</span>
              </div>
              <div style={{flexFlow: "row"}}>
                <br/><span style={{textDecoration: "underline"}}>One salad:</span><br/><span> Greek - Caesar - Fresh Garden</span>
              </div>
              <div style={{flexFlow: "row"}}>
                <br/><span style={{textDecoration: "underline"}}>One pasta:</span><br/><span> Tortellini Pink Vodka - Fusilli Primavera - Ziti Pomodoro - Rigatoni Bolognese - Penne Arrabiata - Bow Tie Broccoli Aglio e Olio</span>
              </div>
              <div style={{flexFlow: "row"}}>
                <br/><span style={{textDecoration: "underline"}}>Three entrees:</span><br/><span> Baked Ham with Pineapple - Steak Tips with Mushroom & Onions - Chicken Francese - Veal with Mushroom & Onions - Chicken Piccata - Eggplant Parmigiana - Chicken Marsala - Sausage & Peppers - Meatballs Pomodoro - Chicken Parmigiana - Roast Pork Loin - Roasted Bone-in Chicken - New England Style Baked Cod - Sole Francese</span>
              </div>
              <div style={{flexFlow: "row"}}>
                <br/><span style={{textDecoration: "underline"}}>One side dish:</span><br/><span> Sauteed Vegetables - Rice & Beans - Macaroni & Cheese - Baby Red Roasted Potatoes - Rice Pilaf - Green Beans - Grilled Vegetables</span>
              </div><br/>

              <span style={{fontWeight: "bold"}}>- ATWELLS AVE</span>
              <span>($40.95 per person)</span><br/>
              <span>Choice of:</span>              
              <div style={{flexFlow: "row"}}>
                <span style={{textDecoration: "underline"}}>Two appetizers:</span><br/><span> Sea Scallops & Bacon - Mozzarella Sticks - Sausage and Roasted Pepper Sticks - Chicken Teriyaki Satay - Asparagus with Rosemary Ham - Fried Ravioli - Vegetable Spring Rolls - Margherita Pizza - Caprese Bruschetta</span>
              </div>
              <div style={{flexFlow: "row"}}>
                <br/><span style={{textDecoration: "underline"}}>One salad:</span><br/><span> Fresh Garden - Caesar - Greek - Baby Greens</span>
              </div>
              <div style={{flexFlow: "row"}}>
                <br/><span style={{textDecoration: "underline"}}>Two pastas:</span><br/><span> Meat & Cheese Lasagna - Penne Pink Vodka - Cheese Tortellini Alfredo - Bow Tie Pomodoro - Rigatoni Bolognese - Cavatelli Broccoli Aglio e Olio - Fusilli Primavera - Penne Puttanesca</span>
              </div>
              <div style={{flexFlow: "row"}}>
                <br/><span style={{textDecoration: "underline"}}>Four entrees:</span><br/><span> Roast Pork Loin - New England Style Baked Cod - Eggplant Parmigiana - Veal Parmigiana - Steak Pizzaiola - Chicken Marsala - Meatball Pomodoro - Chicken Francese - Veal Mushroom & Peas - Chicken Piccata - Roasted Bone-in Quarter Chicken - Sausage & Peppers - Chicken Parmigiana - Sole Francese - Baked Ham with Pineapple</span>
              </div>
              <div style={{flexFlow: "row"}}>
                <br/><span style={{textDecoration: "underline"}}>One side dish:</span><br/><span> Sauteed Vegetables - Rice & Beans - Macaroni & Cheese - Baby Red Roasted Potatoes - Rice Pilaf - Green Beans - Grilled Vegetables - Mashed Potatoes - Broccoli Limone</span>
              </div><br/>

              <span style={{fontWeight: "bold"}}>- CHEF SPECIAL</span>
              <span>($44.95 per person)</span><br/>
              <span>Choice of:</span>              
              <div style={{flexFlow: "row"}}>
                <span style={{textDecoration: "underline"}}>Three appetizers:</span><br/><span> Mini Beef Wellington - Mozzarella Wrapped with Prosciutto - Smoked Salmon Canapes - Clams Casino - Bacon Wrapped Beef Filet - Chicken Pot Stickers - Sea Scallops & Bacon - Beef Teriyaki Skewers - Caprese Crostini - Crab Rangoon</span>
              </div>
              <div style={{flexFlow: "row"}}>
                <br/><span style={{textDecoration: "underline"}}>One salad:</span><br/><span> Caesar - Greek - Mesclun - Fresh Garden - Baby Arugula</span>
              </div>
              <div style={{flexFlow: "row"}}>
                <br/><span style={{textDecoration: "underline"}}>Two pastas:</span><br/><span> Cavatelli with Broccoli Rabe & Crumbled Sausage - Tortellini Pink Vodka - Penne Pomodoro - Rigatoni Bolognese - Fusilli Primavera - Three Cheese Lasagna - Bow Tie with Broccoli Aglio e Olio - Ziti Arrabiata</span>
              </div>
              <div style={{flexFlow: "row"}}>
                <br/><span style={{textDecoration: "underline"}}>Four entrees:</span><br/><span> Roast Pork Loin - New England Style Baked Cod - Eggplant Parmigiana - Veal Parmigiana - Steak Pizzaiola - Chicken Marsala - Meatball Pomodoro - Chicken Francese - Veal with Mushrooms & Peas - Chicken Piccata - Roasted Bone-in Quarter Chicken - Sausage & Peppers - Chicken Parmigiana - Sole Francese - Baked Ham with Pineapple</span>
              </div>
              <div style={{flexFlow: "row"}}>
                <br/><span style={{textDecoration: "underline"}}>Two side dishes:</span><br/><span> Ratatouille - Mashed Potatoes - Sauteed Vegetables - Rice Pilaf - Macaroni & Cheese - Grilled Vegetables - Green Beans - Rice & Beans - Baby Red Roasted Potatoes - Broccoli Limone - Sauteed Escarole - Broccoli Rabe with Garlic & Oil</span>
              </div>
            </div>
          </div>

          {/* Dinner */}

          <div className="dining-section-header">
            <span>Dinner Packages</span>
          </div>
          
          <div className="catering-section-container">
            <div className="catering-left-align">
              <button className="order-now-button">Inquire to schedule event</button>
              
              <span>* All served individually</span>
              <span>* You may offer your guests up to three entree choices</span>
              <span>* Host is responsible to have meal cards</span>
              <span>* Add soup for $2.00 per person: Chicken Escarole - Minestrone - Pasta & Beans - Escarole & Beans</span><br/>
            

              <span style={{fontWeight: "bold"}}>- DINNER PACKAGES</span><br/>

              <div className="large">

                <div className="medium">
                  <div className="medium-header">
                    <span>BEEF / PORK / LAMB ENTREES</span>
                  </div>

                  <div className="small">
                    <div className="small-left">
                      <span>Grilled Rib Eye Steak</span>
                    </div>
                    <span className="small-right">
                      <span>$42.95</span>
                    </span>
                  </div>                    
                  <div className="small">
                    <div className="small-left">
                      <span>Prime Rib or Beef</span>
                    </div>
                    <div className="small-right">
                        <span>$42.95</span>
                      </div>
                  </div>
                  <div className="small">
                    <div className="small-left">
                      <span>Grilled Beef Tenderloin</span>
                    </div>
                    <div className="small-right">
                        <span>$42.95</span>
                      </div>
                  </div>
                  <div className="small">
                    <div className="small-left">
                      <span>Grilled N.Y. Strip</span>
                    </div>
                    <div className="small-right">
                      <span>$42.95</span>
                    </div>
                  </div>
                  <div className="small">
                    <div className="small-left">
                      <span>Herb Crusted Pork Loin</span>
                    </div>
                    <div className="small-right">
                      <span>$32.95</span>
                    </div>
                  </div>
                  <div className="small">
                    <div className="small-left">
                      <span>Grilled Loin Lamb Chops</span>
                    </div>
                    <div className="small-right">
                      <span>$44.95</span>
                    </div>
                  </div>
                </div>

                <div className="medium">
                  <div className="medium-header">
                    <span>CHICKEN ENTREES</span>
                  </div>

                  <div className="small">
                    <div className="small-left">
                      <span>Chicken Francese</span>
                    </div>
                    <span className="small-right">
                      <span>$27.95</span>
                    </span>
                  </div>                    
                  <div className="small">
                    <div className="small-left">
                      <span>Chicken Saltimbocca</span>
                    </div>
                    <div className="small-right">
                        <span>$27.95</span>
                      </div>
                  </div>
                  <div className="small">
                    <div className="small-left">
                      <span>Chicken Marsala</span>
                    </div>
                    <div className="small-right">
                        <span>$27.95</span>
                      </div>
                  </div>
                  <div className="small">
                    <div className="small-left">
                      <span>Chicken Parmigiana</span>
                    </div>
                    <div className="small-right">
                      <span>$27.95</span>
                    </div>
                  </div>
                  <div className="small">
                    <div className="small-left">
                      <span>Chicken Rollatini</span>
                    </div>
                    <div className="small-right">
                      <span>$26.95</span>
                    </div>
                  </div>
                  <div className="small">
                    <div className="small-left">
                      <span>Roasted Half Chicken</span>
                    </div>
                    <div className="small-right">
                      <span>$22.95</span>
                    </div>
                  </div>
                  <div className="small">
                    <div className="small-left">
                      <span>Chicken Piccata</span>
                    </div>
                    <div className="small-right">
                      <span>$27.95</span>
                    </div>
                  </div>
                  <div className="small">
                    <div className="small-left">
                      <span>Chicken Caprese</span>
                    </div>
                    <div className="small-right">
                      <span>$27.95</span>
                    </div>
                  </div>
                </div>

                <div className="medium">
                  <div className="medium-header">
                    <span>VEAL ENTREES</span>
                  </div>

                  <div className="small">
                    <div className="small-left">
                      <span>Veal Saltimbocca</span>
                    </div>
                    <span className="small-right">
                      <span>$37.95</span>
                    </span>
                  </div>                    
                  <div className="small">
                    <div className="small-left">
                      <span>Veal Parmigiana</span>
                    </div>
                    <div className="small-right">
                        <span>$37.95</span>
                      </div>
                  </div>
                  <div className="small">
                    <div className="small-left">
                      <span>Veal Marsala</span>
                    </div>
                    <div className="small-right">
                        <span>$37.95</span>
                      </div>
                  </div>
                  <div className="small">
                    <div className="small-left">
                      <span>Veal Milanese</span>
                    </div>
                    <div className="small-right">
                      <span>$37.95</span>
                    </div>
                  </div>
                </div>

                <div className="medium">
                  <div className="medium-header">
                    <span>FISH / CLASSIC ENTREES</span>
                  </div>

                  <div className="small">
                    <div className="small-left">
                      <span>N.E. Style Baked Cod</span>
                    </div>
                    <span className="small-right">
                      <span>$36.95</span>
                    </span>
                  </div>                    
                  <div className="small">
                    <div className="small-left">
                      <span>Grilled Salmon Fillet</span>
                    </div>
                    <div className="small-right">
                        <span>$38.95</span>
                      </div>
                  </div>
                  <div className="small">
                    <div className="small-left">
                      <span>Baked Stuffed Shrimp (3)</span>
                    </div>
                    <div className="small-right">
                        <span>$30.95</span>
                      </div>
                  </div>
                  <div className="small">
                    <div className="small-left">
                      <span>Sole Francese</span>
                    </div>
                    <div className="small-right">
                      <span>$27.95</span>
                    </div>
                  </div>
                  <div className="small">
                    <div className="small-left">
                      <span>Cod Italiano</span>
                    </div>
                    <div className="small-right">
                      <span>$36.95</span>
                    </div>
                  </div>
                  <div className="small">
                    <div className="small-left">
                      <span>Beef Tenderloin & Baked Stuffed Shrimp (3)</span>
                    </div>
                    <div className="small-right">
                      <span>$44.95</span>
                    </div>
                  </div>
                </div>
              </div>

              <br/><span>Choice of:</span>                            
              <div style={{flexFlow: "row"}}>
                <span style={{textDecoration: "underline"}}>One appetizer:</span><br/><span> Sea Scallops and Bacon - Stuffed Mushroom Caps with or without Crabmeat - Mini Rice Arancini - Sausage and Roast Pepper Skewer - Potato Croquettes - Tomato, Onion, and Cheese Focaccia - Spanakopita - Cold Cut, Spinach and Cheese Calzone - Prosciutto Wrapped with Melon - Asparagus with Rosemary Ham - Eggplant Crostini - Wild Mushroom Crostini - Plum, Tomato and Mozzarella Bruschetta</span>
              </div>
              <div style={{flexFlow: "row"}}>
                <br/><span style={{textDecoration: "underline"}}>One pasta:</span><br/><span> Penne Pomodoro and Basil - Farfalle Pink Vodka - Rigatoni Bolognese - Fettuccine alfredo - Cavatelli Aglio e Olio - Fusilli with Prosciutto - Peas and Onion Cream Sauce - Gemelli Puttanesca - Ziti Carbonara - Pennette Siciliana</span>
              </div>
              <div style={{flexFlow: "row"}}>
                <br/><span style={{textDecoration: "underline"}}>Two side dishes:</span><br/><span> Red Roasted Potatoes - Sauteed Seasonal Vegetables - Sauteed Cauliflower and Baby Carrots - Grilled Seasonal Vegetables - Broccoli Limone - Rice Pilaf - Couscous - Baked Idaho Potato - Green Beans any style - Roasted Garlic Mashed Potatoes - Sauteed Escarole</span>
              </div>
              <div style={{flexFlow: "row"}}>
                <br/><span style={{textDecoration: "underline"}}>One salad (add $2.00 per person):</span><br/><span> Caesar - Greek - Baby Greens - Fresh Garden - Antipasto over Mesclun</span>
              </div>
              <div style={{flexFlow: "row"}}>
                <br/><span style={{textDecoration: "underline"}}>One soup (add $2.00 per person):</span><br/><span> Chicken Escarole - Minestrone - Pasta & Beans - Escarole & Beans</span>
              </div>              
            </div>
          </div>          
        </div>

        <Footer />

      </div>

      {warnModal ?
        <WarnModal 
          warnNav={warnNav} 
          onClose={() => setWarnModal(false)} 
        />
      : null}

    </div>
  )
}

export default Catering
